import React from "react";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import * as m from "@/paraglide/messages";

type Props = {};

export default function bentoExit({}: Props) {
  return (
    <>
      <Card className="relative col-span-full overflow-hidden lg:col-span-3">
        <CardHeader></CardHeader>
        <CardContent>
          <div className="grid items-center sm:grid-cols-2">
            <div className="relative z-10 flex flex-col justify-between space-y-6 lg:space-y-6">
              <div className="relative flex aspect-square size-12 rounded-full border before:absolute before:-inset-2 before:rounded-full before:border dark:border-white/10 dark:bg-white/5 dark:before:border-white/5 dark:before:bg-white/5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="m-auto size-6"
                >
                  <polyline points="22 17 13.5 8.5 8.5 13.5 2 7" />
                  <polyline points="16 17 22 17 22 11" />
                </svg>
              </div>
              <div className="space-y-2">
                <h2 className="text-lg font-bold text-foreground">
                  {m.main_kind_swan_coax()}
                </h2>
                <p className="text-muted-foreground">
                  {m.dirty_bland_lizard_walk()}
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-2 sm:ml-6 sm:mt-8">
              <div className="flex items-center gap-2">
                {" "}
                <span className="text-xs">When my</span>
                <Select>
                  <SelectTrigger className="w-fit text-xs">
                    <SelectValue placeholder="Portfolio" />
                  </SelectTrigger>
                  <SelectContent className="text-xs">
                    <SelectItem className="text-xs" value="portfolio">
                      {m.my_portfolio()}
                    </SelectItem>
                    <SelectItem className="text-xs" value="btc">
                      Bitcoin
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="flex items-center gap-2">
                <Select>
                  <SelectTrigger className="w-fit text-xs">
                    <SelectValue placeholder="Drops" />
                  </SelectTrigger>
                  <SelectContent className="text-xs">
                    <SelectItem className="text-xs" value="drops">
                      {m.drops()}
                    </SelectItem>
                    <SelectItem className="text-xs" value="increase">
                      {m.increase()}
                    </SelectItem>
                  </SelectContent>
                </Select>
                <span className="text-xs">{m.by()}</span>
                <Input
                  value={100}
                  type="number"
                  max={100}
                  className=" w-16 rounded-sm text-right text-xs"
                  readOnly
                ></Input>
                <span className="text-xs">%</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs">{m.sell()}</span>

                <Input
                  value={100}
                  type="number"
                  max={100}
                  className="w-16 rounded-sm text-xs"
                  readOnly
                ></Input>
                <span className="text-xs">%</span>
              </div>
              <Button size={"sm"} className="w-fit text-xs">
                {m.save_rule()}
              </Button>
            </div>
          </div>
        </CardContent>
        <CardFooter></CardFooter>
      </Card>
    </>
  );
}
